import { TUserType, userTypeConvert } from "../helper";

export default function getUserStatus(userTypeEnum: TUserType, userLookingForTypeEnum: TUserType,plural?:boolean) {
  const userType = userTypeConvert(userTypeEnum);
  const userLookingForType = userTypeConvert(userLookingForTypeEnum,undefined, plural);
  const article = !plural ? ["Allies", "Ally"].includes(userLookingForType) ? "an" : "a" : "";

  return `${userType ? userType + ", " : ""}Actively looking for ${article} ${userLookingForType}`;
}
